'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { getEmailProvider } from '../../../data/api/email/email.js';
import '@dynamic-labs/sdk-api-core';
import '@dynamic-labs/utils';
import '../../../store/state/user/user.js';
import '../../../utils/constants/values.js';
import '../../../store/state/projectSettings/projectSettings.js';
import '../../../config/ApiEndpoint.js';
import '@dynamic-labs/multi-wallet';
import '../../../shared/logger.js';
import '../../../utils/constants/colors.js';
import 'react-international-phone';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react';
import 'react/jsx-runtime';
import '../../ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../../shared/consts/index.js';
import '../../../store/state/nonce/nonce.js';
import '../../../store/state/dynamicContextProps/dynamicContextProps.js';
import '../../../store/state/primaryWalletId/primaryWalletId.js';
import '../../../locale/locale.js';
import { allSupportedProviders } from '../constants.js';

const findEmailProvider = (environmentId, email) => __awaiter(void 0, void 0, void 0, function* () {
    const { emailProvider } = yield getEmailProvider({
        email,
        environmentId,
    });
    if (!allSupportedProviders.includes(emailProvider)) {
        throw new Error('Email provider is not supported');
    }
    return emailProvider;
});

export { findEmailProvider };
